"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgHomeTheater = function SvgHomeTheater(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5h15v11h-15z",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 1.5 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    d: "M.5.5h19v3H.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 2,
    cy: 2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 5,
    cy: 2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 9,
    cy: 2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 13,
    cy: 2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 17,
    cy: 2,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 10.5 12.5)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    d: "M.5.5h19v3H.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 2,
    cy: 2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4D4D4D",
    cx: 5,
    cy: 2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 9,
    cy: 2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 13,
    cy: 2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#4D4D4D",
    cx: 17,
    cy: 2,
    r: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6 19.5h11.946",
    stroke: "#4D4D4D"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgHomeTheater);
var _default = exports["default"] = Memo;